import React from "react";
import { motion } from "framer-motion";
import { Dumbbell, Zap, Droplet, Flame, Wheat, Pill, Cookie, Boxes } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/motion/Reveal";

const products = [
  { icon: <Dumbbell className="w-6 h-6" />, name: "Proteínas", items: "Whey concentrada (WPC), aislada (WPI) e hidrolizada", image: "https://images.pexels.com/photos/6287320/pexels-photo-6287320.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { icon: <Zap className="w-6 h-6" />, name: "Pre-entrenos", items: "Con y sin cafeína", image: "https://images.pexels.com/photos/15120889/pexels-photo-15120889.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { icon: <Droplet className="w-6 h-6" />, name: "Aminoácidos", items: "BCAAs, EAAs, glutamina, beta-alanina, citrulina, AKG-HMB", image: "https://images.pexels.com/photos/12625114/pexels-photo-12625114.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { icon: <Flame className="w-6 h-6" />, name: "Creatinas", items: "Creatina neutra y otros formatos", image: "/media/creatina.png" },
  { icon: <Wheat className="w-6 h-6" />, name: "Gainers y carbohidratos", items: "Ganadores de peso y aporte calórico", image: "https://images.pexels.com/photos/6294375/pexels-photo-6294375.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { icon: <Cookie className="w-6 h-6" />, name: "Cremas", items: "Cremas de cacahuete", image: "https://images.pexels.com/photos/5149346/pexels-photo-5149346.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { icon: <Pill className="w-6 h-6" />, name: "Cápsulas y softgels", items: "Melatonina, L-Carnitina, vitaminas, minerales, omega 3, Q10 y otros", image: "https://images.pexels.com/photos/14744701/pexels-photo-14744701.jpeg?auto=compress&cs=tinysrgb&w=900" },
  { icon: <Boxes className="w-6 h-6" />, name: "Formatos de venta", items: "Botes PET/PP/HDPE · Doypacks · Sobres monodosis 11,5–30 g · Cajas", image: "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/qkt10n20_22.jpg" },
];

export default function Products() {
  return (
    <section id="productos" className="relative py-10 md:py-14 bg-[#F8FAFC] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="mb-10 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold mb-4">/ 04 · Portfolio</div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1628] uppercase tracking-tighter leading-[1]">
            Categorías que <span className="text-[#0A84E2]">fabricamos.</span>
          </h2>
          <p className="mt-6 text-slate-600 text-lg">Más de 1.000 referencias activas y capacidad para desarrollar cualquier fórmula personalizada dentro de la normativa alimentaria nacional y europea.</p>
        </Reveal>

        <RevealGroup stagger={0.07} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {products.map((p, i) => (
            <RevealItem key={i}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 300, damping: 24 }}
                data-testid={`product-card-${i}`}
                className="corp-card rounded-sm overflow-hidden flex flex-col group h-full"
              >
                {p.image && (
                  <div className="relative h-44 overflow-hidden bg-[#0A1628]">
                    <img src={p.image} alt={p.name} className="w-full h-full object-cover opacity-95 group-hover:scale-110 group-hover:opacity-100 transition-all duration-700" />
                    {/* editorial spotlight + clipped corner */}
                    <div className="absolute inset-0 bg-gradient-to-t from-white via-white/5 to-transparent" />
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ background: "radial-gradient(circle at 50% 30%, rgba(10,132,226,0.25), transparent 60%)" }} />
                    <div className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-widest text-white/80 bg-black/20 backdrop-blur-sm px-2 py-0.5 rounded-sm">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                  </div>
                )}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="w-10 h-10 rounded-sm bg-[#EFF6FF] flex items-center justify-center text-[#0A84E2] mb-4 group-hover:bg-[#0A84E2] group-hover:text-white transition-colors">{p.icon}</div>
                  <h3 className="font-display text-xl font-semibold text-[#0A1628]">{p.name}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.items}</p>
                </div>
              </motion.div>
            </RevealItem>
          ))}
        </RevealGroup>

        <div className="mt-12 text-center">
          <a href="#contacto" data-testid="products-cta" className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A1628] border-b-2 border-[#0A84E2] pb-1 hover:text-[#0A84E2] transition-colors uppercase tracking-widest">
            ¿No encuentras tu producto? Consúltanos →
          </a>
        </div>
      </div>
    </section>
  );
}
